module.exports = __webpack_public_path__ + "static/media/gallery-4.267ae822.jpg";